// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PaymentCardMaskedNumber_paymentCard_graphql = require("../../../__generated__/PaymentCardMaskedNumber_paymentCard_graphql.bs.js");

let convertFragment = PaymentCardMaskedNumber_paymentCard_graphql.Internal.convertFragment;

function PaymentCardMaskedNumber(props) {
  let __className = props.className;
  let className = __className !== undefined ? __className : "";
  let card = RescriptRelay_Fragment.useFragment(PaymentCardMaskedNumber_paymentCard_graphql.node, convertFragment, props.card);
  let match = card.brand;
  let maskedNumber;
  maskedNumber = match === "AMERICAN_EXPRESS" || match === "VISA" || match === "DISCOVER" || match === "MASTERCARD" ? (
      match === "AMERICAN_EXPRESS" ? `**** ****** *` + card.lastFour : `**** **** **** ` + card.lastFour
    ) : `**** **** **** ` + card.lastFour;
  return JsxRuntime.jsx("div", {
    children: maskedNumber,
    className: className
  });
}

let make = PaymentCardMaskedNumber;

exports.make = make;
/* react/jsx-runtime Not a pure module */
